/**
 * getStoredTheme — Read the persisted theme preference from localStorage.
 * Not a React hook — plain function, safe to call anywhere.
 * Shared by AuthGate and RetreatBridge so both use the same default.
 * Defaults to "light" (parchment) per Task 23 / PV-14.
 */
import { STORAGE_KEYS } from "../constants";

export function getStoredTheme(): "light" | "dark" {
  try {
    return (localStorage.getItem(STORAGE_KEYS.THEME) as "light" | "dark") || "light";
  } catch {
    return "light";
  }
}
